var forOwn = require('./forOwn');

    /**
     * Get object values
     */
    function values(obj) {
        var vals = [];
        forOwn(obj, function(val, key){
            vals.push(val);
        });
        return vals;
    }

    module.exports = values;





//////////////////
// WEBPACK FOOTER
// ./~/mout/object/values.js
// module id = 273
// module chunks = 0 1 2